module.exports = __webpack_public_path__ + "static/fingerClick-e8212826c6f6923bb90be34e4237cd79.gif";